/* ==========================================================================
   CALYRE — global.js (vanilla, sans dépendance)
   ========================================================================== */
(function () {
  'use strict';

  var C = window.CALYRE || { routes: {}, strings: {} };
  var $ = function (s, ctx) { return (ctx || document).querySelector(s); };
  var $$ = function (s, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(s)); };
  var isDesktop = function () { return window.matchMedia('(min-width: 990px)').matches; };

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || C.moneyFormat || '{{amount_with_comma_separator}} €';
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var match = format.match(placeholder);
    switch (match ? match[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  /* ---------------- Toast ---------------- */
  var toastEl = $('[data-toast]'), toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2800);
  }

  /* ---------------- Overlay & drawers ---------------- */
  var overlay = $('[data-overlay]');
  var openDrawerEl = null, lastFocus = null;

  function showOverlay() {
    overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
    document.body.classList.add('is-locked');
  }
  function hideOverlay() {
    overlay.classList.remove('is-visible');
    document.body.classList.remove('is-locked');
    setTimeout(function () { if (!openDrawerEl && !searchOpen) overlay.hidden = true; }, 350);
  }

  function openDrawer(name) {
    var el = document.querySelector('[data-drawer="' + name + '"]');
    if (!el) return false;
    if (openDrawerEl && openDrawerEl !== el) closeDrawer(true);
    closeSearch(true);
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    openDrawerEl = el;
    document.documentElement.classList.toggle('header-raised', !!el.closest('.section-header'));
    showOverlay();
    $$('[data-drawer-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () { el.focus({ preventScroll: true }); }, 50);
    return true;
  }
  function closeDrawer(keepOverlay) {
    if (!openDrawerEl) return;
    var name = openDrawerEl.getAttribute('data-drawer');
    openDrawerEl.classList.remove('is-open');
    if (!searchOpen) document.documentElement.classList.remove('header-raised');
    $$('[data-drawer-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    openDrawerEl = null;
    if (!keepOverlay) hideOverlay();
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }
    var cartOpener = e.target.closest('[data-cart-open]');
    if (cartOpener && C.cartType === 'drawer' && $('[data-drawer="cart"]')) {
      e.preventDefault();
      openDrawer('cart');
    }
  });
  if (overlay) overlay.addEventListener('click', function () { closeDrawer(); closeSearch(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeSearch(); closeLightbox(); closePopup(); }
  });

  /* ---------------- Header ---------------- */
  var header = $('[data-header]');
  var headerWrapper = $('[data-header-wrapper]');
  var isTransparent = headerWrapper && headerWrapper.classList.contains('site-header-wrapper--transparent');
  var lastY = window.scrollY;
  function setHeaderHeight() {
    if (!header) return;
    document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
  }
  var headerSection = header ? header.closest('.shopify-section') : null;
  function onScroll() {
    if (!header) return;
    var y = window.scrollY;
    if (isTransparent) header.classList.toggle('is-solid', y > 40);
    if (header.getAttribute('data-hide-on-scroll') === 'true' && headerSection && !openDrawerEl && !searchOpen) {
      var hide = y > 300 && y > lastY + 4;
      var show = y < lastY - 4 || y < 300;
      if (hide) { headerSection.classList.add('is-hidden'); document.documentElement.style.setProperty('--header-h', '0px'); }
      else if (show) { headerSection.classList.remove('is-hidden'); setHeaderHeight(); }
    }
    lastY = y;
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', debounce(setHeaderHeight, 150));
  setHeaderHeight();
  onScroll();

  /* Transparent header on home: pull the first hero under the header */
  if (isTransparent) {
    var firstHero = $('main > .shopify-section:first-child .hero');
    if (firstHero && header) {
      firstHero.classList.add('hero--under-header');
      document.documentElement.style.setProperty('--header-base', header.offsetHeight + 'px');
      window.addEventListener('resize', debounce(function () {
        document.documentElement.style.setProperty('--header-base', header.offsetHeight + 'px');
      }, 150));
    } else {
      headerWrapper.classList.remove('site-header-wrapper--transparent');
      isTransparent = false;
    }
  }

  /* ---------------- Announcement rotation ---------------- */
  $$('[data-announcement]').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var i = 0, speed = (parseInt(bar.getAttribute('data-speed'), 10) || 5) * 1000;
    setInterval(function () {
      if (isDesktop() && $('.announcement__track--inline', bar)) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, speed);
  });

  /* ---------------- Search ---------------- */
  var searchPanel = $('[data-search-panel]');
  var searchOpen = false;
  var searchInput = $('[data-predictive-input]');
  var resultsBox = $('[data-predictive-results]');
  var resultsDefault = resultsBox ? resultsBox.innerHTML : '';
  function openSearch() {
    if (!searchPanel) return;
    closeDrawer(true);
    searchPanel.classList.add('is-open');
    searchOpen = true;
    document.documentElement.classList.add('header-raised');
    showOverlay();
    setTimeout(function () { searchInput && searchInput.focus(); }, 80);
  }
  function closeSearch(keepOverlay) {
    if (!searchPanel || !searchOpen) return;
    searchPanel.classList.remove('is-open');
    searchOpen = false;
    if (!openDrawerEl || !openDrawerEl.closest('.section-header')) document.documentElement.classList.remove('header-raised');
    if (!keepOverlay) hideOverlay();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
  });
  var searchController;
  if (searchInput && resultsBox) {
    searchInput.addEventListener('input', debounce(function () {
      var q = searchInput.value.trim();
      if (q.length < 2) { resultsBox.innerHTML = resultsDefault; return; }
      if (searchController) searchController.abort();
      searchController = 'AbortController' in window ? new AbortController() : null;
      var url = C.routes.predictiveSearch + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page,query&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search';
      fetch(url, searchController ? { signal: searchController.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.querySelector('.shopify-section') || doc.body;
          resultsBox.innerHTML = section.innerHTML;
        })
        .catch(function () {});
    }, 220));
  }

  /* ---------------- Cart ---------------- */
  function getSectionsToRender() {
    var s = [];
    if ($('[data-drawer="cart"]')) s.push('cart-drawer');
    return s;
  }

  function renderCartSections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = doc.querySelector('[data-drawer="cart"]');
      var current = $('[data-drawer="cart"]');
      if (fresh && current) {
        var wasOpen = current.classList.contains('is-open');
        var scroll = $('[data-cart-body]', current) ? $('[data-cart-body]', current).scrollTop : 0;
        current.innerHTML = fresh.innerHTML;
        if (wasOpen) current.classList.add('is-open');
        var body = $('[data-cart-body]', current);
        if (body) body.scrollTop = scroll;
      }
    }
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.setAttribute('data-count', count);
    });
  }

  function refreshCount() {
    return fetch(C.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); return cart; });
  }

  function addToCart(formData, button) {
    if (button) button.classList.add('is-loading');
    var sections = getSectionsToRender();
    if (sections.length) {
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);
    }
    return fetch(C.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status !== 200) throw res;
        renderCartSections(res.sections);
        refreshCount();
        if (C.cartType === 'drawer' && $('[data-drawer="cart"]')) {
          openDrawer('cart');
        } else {
          toast(C.strings.added || 'Ajouté au panier');
        }
        document.dispatchEvent(new CustomEvent('cart:added', { detail: res }));
        return res;
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || C.strings.error;
        toast(msg);
        var box = $('[data-form-error]');
        if (box && button && button.closest('[data-product-form]')) { box.textContent = msg; box.hidden = false; }
        throw err;
      })
      .finally(function () { if (button) button.classList.remove('is-loading'); });
  }

  function changeLine(line, quantity) {
    var container = $('[data-drawer="cart"]') || $('[data-cart-page]');
    if (container) container.classList.add('is-updating');
    var body = { line: parseInt(line, 10), quantity: Math.max(0, parseInt(quantity, 10) || 0) };
    var sections = getSectionsToRender();
    var cartPage = $('[data-cart-page]');
    if (cartPage && cartPage.closest('.shopify-section')) {
      sections.push(cartPage.closest('.shopify-section').id.replace('shopify-section-', ''));
    }
    if (sections.length) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }
    return fetch(C.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.status && cart.status !== 200) throw cart;
        renderCartSections(cart.sections);
        if (cartPage && cart.sections) {
          var id = cartPage.closest('.shopify-section').id.replace('shopify-section-', '');
          if (cart.sections[id]) {
            var doc = new DOMParser().parseFromString(cart.sections[id], 'text/html');
            var fresh = doc.querySelector('[data-cart-page]');
            if (fresh) cartPage.innerHTML = fresh.innerHTML;
          }
        }
        updateCount(cart.item_count);
      })
      .catch(function (err) { toast((err && err.description) || C.strings.error); })
      .finally(function () {
        var c = $('[data-drawer="cart"]'); if (c) c.classList.remove('is-updating');
        var p = $('[data-cart-page]'); if (p) p.classList.remove('is-updating');
      });
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-qty-change]');
    if (q) { e.preventDefault(); changeLine(q.getAttribute('data-qty-change'), q.getAttribute('data-qty')); return; }
    var qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      var fd = new FormData();
      fd.append('id', qa.getAttribute('data-quick-add'));
      fd.append('quantity', '1');
      addToCart(fd, qa).catch(function () {});
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) changeLine(input.getAttribute('data-qty-input'), input.value);
  });
  document.addEventListener('input', debounce(function (e) {
    var note = e.target.closest && e.target.closest('[data-cart-note]');
    if (!note) return;
    fetch(C.routes.cartUpdate + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note.value })
    });
  }, 500));

  /* ---------------- Product page ---------------- */
  $$('[data-product-section]').forEach(function (section) {
    var form = $('[data-product-form]', section);
    if (!form) return;
    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add-button]', form);
    var addLabel = $('[data-add-label]', form);
    var picker = $('[data-variant-picker]', section);
    var variantsEl = $('[data-variants-json]', section);
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var invEl = $('[data-inventory-json]', section);
    var inventory = invEl ? JSON.parse(invEl.textContent) : {};
    var stockBox = $('[data-stock]', section);
    var errorBox = $('[data-form-error]', section);
    var sticky = $('[data-sticky-atc]', section);
    var stickyBtn = sticky ? $('[data-sticky-add]', sticky) : null;
    var stickyLabel = sticky ? $('[data-sticky-label]', sticky) : null;
    var stickyPrice = sticky ? $('[data-sticky-price]', sticky) : null;
    var gallery = $('[data-gallery-track]', section);

    function selectedOptions() {
      var opts = [];
      $$('fieldset', picker).forEach(function (fs, i) {
        var checked = $('input:checked', fs);
        opts[i] = checked ? checked.value : null;
      });
      return opts;
    }

    function priceHTML(v) {
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      var html = '<div class="price price--large' + (sale ? ' price--sale' : '') + '"><span class="price__current">' + formatMoney(v.price) + '</span>';
      if (sale) {
        var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        html += '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s><span class="price__save">-' + pct + '%</span>';
      }
      return html + '</div>';
    }

    function markAvailability(opts) {
      $$('fieldset', picker).forEach(function (fs, i) {
        $$('input', fs).forEach(function (input) {
          var test = opts.slice();
          test[i] = input.value;
          var ok = variants.some(function (v) {
            return v.available && v.options.every(function (o, j) { return o === test[j]; });
          });
          input.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function updateStock(v) {
      if (!stockBox || !v) return;
      var threshold = parseInt(stockBox.getAttribute('data-threshold'), 10) || 3;
      var inv = inventory[v.id] || {};
      var html;
      if (!v.available) html = '<p class="stock-note stock-note--out">' + C.strings.soldOut + '</p>';
      else if (inv.m === 'shopify' && inv.q > 0 && inv.q <= threshold) html = '<p class="stock-note stock-note--low">' + (inv.q === 1 ? 'Plus qu’une pièce disponible' : 'Plus que ' + inv.q + ' pièces disponibles') + '</p>';
      else html = '<p class="stock-note">En stock, prêt à être expédié</p>';
      stockBox.innerHTML = html;
    }

    function onVariantChange() {
      var opts = selectedOptions();
      $$('[data-option-value]', picker).forEach(function (el) {
        el.textContent = opts[parseInt(el.getAttribute('data-option-value'), 10)] || '';
      });
      markAvailability(opts);
      var v = variants.find(function (x) { return x.options.every(function (o, j) { return o === opts[j]; }); });
      if (errorBox) errorBox.hidden = true;
      if (!v) {
        addBtn.disabled = true;
        addLabel.textContent = C.strings.unavailable;
        if (stickyBtn) { stickyBtn.disabled = true; stickyLabel.textContent = C.strings.unavailable; }
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? C.strings.addToCart : C.strings.soldOut;
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyLabel.textContent = addLabel.textContent; }
      var pw = $('[data-price-wrapper]', section);
      if (pw) pw.innerHTML = priceHTML(v);
      if (stickyPrice) stickyPrice.innerHTML = priceHTML(v).replace(' price--large', '');
      updateStock(v);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      if (v.featured_media && gallery) {
        var target = gallery.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (target) {
          if (isDesktop()) {
            var first = gallery.firstElementChild;
            if (first !== target) gallery.insertBefore(target, first);
          } else {
            gallery.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
          }
        }
      }
      form.dispatchEvent(new CustomEvent('variant:change', { detail: v, bubbles: true }));
    }

    if (picker) {
      picker.addEventListener('change', onVariantChange);
      markAvailability(selectedOptions());
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn.disabled) return;
      var fd = new FormData(form);
      addToCart(fd, addBtn).catch(function () {});
    });

    /* sticky add to cart */
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var below = en.boundingClientRect.top < 0;
          var show = !en.isIntersecting && below;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      });
      io.observe(addBtn);
      stickyBtn.addEventListener('click', function () {
        if (addBtn.disabled) { addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        var fd = new FormData(form);
        addToCart(fd, stickyBtn).catch(function () {});
      });
    }

    /* gallery dots + counter */
    if (gallery) {
      var dots = $$('[data-gallery-dot]', section);
      var counter = $('[data-gallery-index]', section);
      gallery.addEventListener('scroll', debounce(function () {
        if (isDesktop()) return;
        var i = Math.round(gallery.scrollLeft / gallery.clientWidth);
        dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
        if (counter) counter.textContent = i + 1;
      }, 60), { passive: true });
    }

    /* lightbox */
    var lightbox = $('[data-lightbox]', section);
    if (lightbox) {
      section.addEventListener('click', function (e) {
        var z = e.target.closest('[data-zoom]');
        if (!z) return;
        var idx = parseInt(z.getAttribute('data-zoom'), 10);
        $$('img[data-lightbox-src]', lightbox).forEach(function (img) {
          if (!img.src) img.src = img.getAttribute('data-lightbox-src');
        });
        lightbox.hidden = false;
        document.body.classList.add('is-locked');
        var imgs = $$('img', lightbox);
        if (imgs[idx]) setTimeout(function () { imgs[idx].scrollIntoView(); }, 30);
      });
      $('[data-lightbox-close]', lightbox).addEventListener('click', closeLightbox);
    }

    /* delivery estimate */
    var del = $('[data-delivery]', section);
    if (del) {
      var min = parseInt(del.getAttribute('data-min'), 10), max = parseInt(del.getAttribute('data-max'), 10);
      var addBusinessDays = function (d, n) {
        var r = new Date(d);
        while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0 && r.getDay() !== 6) n--; }
        return r;
      };
      try {
        var f = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
        var now = new Date();
        $('[data-delivery-dates]', del).textContent = 'entre le ' + f.format(addBusinessDays(now, min)) + ' et le ' + f.format(addBusinessDays(now, max));
      } catch (err) {}
    }

    /* complementary products */
    var comp = $('[data-complementary]', section);
    if (comp) {
      fetch(comp.getAttribute('data-url'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-complementary]');
          if (fresh && fresh.innerHTML.trim()) comp.innerHTML = fresh.innerHTML;
        }).catch(function () {});
    }
  });

  function closeLightbox() {
    var lb = $('[data-lightbox]:not([hidden])');
    if (!lb) return;
    lb.hidden = true;
    document.body.classList.remove('is-locked');
  }

  /* ---------------- Recommendations ---------------- */
  $$('[data-recommendations]').forEach(function (box) {
    var load = function () {
      fetch(box.getAttribute('data-url'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) { box.innerHTML = fresh.innerHTML; initSliders(box); }
          else box.closest('.shopify-section').style.display = 'none';
        }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' });
      io.observe(box);
    } else load();
  });

  /* ---------------- Sliders ---------------- */
  function initSliders(ctx) {
    $$('[data-slider]', ctx).forEach(function (slider) {
      if (slider.__init) return;
      slider.__init = true;
      var wrap = slider.closest('.page-width') || slider.parentNode;
      var bar = $('[data-slider-progress]', wrap);
      var update = function () {
        if (!bar) return;
        var max = slider.scrollWidth - slider.clientWidth;
        var ratio = slider.clientWidth / slider.scrollWidth;
        bar.style.width = Math.max(ratio * 100, 10) + '%';
        var p = max > 0 ? slider.scrollLeft / max : 0;
        bar.style.transform = 'translateX(' + (p * (1 / Math.max(ratio, .1) - 1) * 100) + '%)';
        bar.parentNode.style.visibility = max > 4 ? 'visible' : 'hidden';
      };
      slider.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', debounce(update, 150));
      update();
      var prev = $('[data-slider-prev]', wrap), next = $('[data-slider-next]', wrap);
      var step = function () { var c = slider.firstElementChild; return c ? c.offsetWidth + 16 : slider.clientWidth; };
      if (prev) prev.addEventListener('click', function () { slider.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { slider.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }
  initSliders(document);

  /* ---------------- Tabs ---------------- */
  $$('[data-tabs]').forEach(function (root) {
    var btns = $$('[data-tab]', root);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var n = b.getAttribute('data-tab');
        btns.forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        $$('[data-panel]', root).forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== n; });
        initSliders(root);
      });
    });
  });

  /* ---------------- Hero slideshow ---------------- */
  $$('[data-hero]').forEach(function (hero) {
    var slides = $$('[data-slide]', hero);
    var dots = $$('[data-dot]', hero);
    if (slides.length < 2) return;
    var i = 0, speed = (parseInt(hero.getAttribute('data-speed'), 10) || 6) * 1000, timer;
    var go = function (n) {
      slides[i].classList.remove('is-active'); if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); if (dots[i]) { dots[i].classList.remove('is-active'); void dots[i].offsetWidth; dots[i].classList.add('is-active'); }
    };
    var play = function () { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, speed); };
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); play(); }); });
    var sx = null;
    hero.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 50) { go(i + (dx < 0 ? 1 : -1)); play(); }
      sx = null;
    });
    play();
  });

  /* ---------------- Reveal on scroll ---------------- */
  if ('IntersectionObserver' in window) {
    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); rio.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { rio.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------------- Collection: sort, filters, load more ---------------- */
  var sortSelect = $('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
  var facetsForm = $('[data-facets-form]');
  if (facetsForm) {
    facetsForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(facetsForm);
      var params = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') params.append(k, v); });
      if (sortSelect && !params.has('sort_by')) params.set('sort_by', sortSelect.value);
      window.location.href = facetsForm.getAttribute('action') + '?' + params.toString();
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-load-more-btn]');
    if (!btn) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    fetch(btn.getAttribute('href'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = $('[data-product-grid]');
        var newGrid = doc.querySelector('[data-product-grid]');
        if (grid && newGrid) {
          $$('.card', newGrid).forEach(function (c) { grid.appendChild(c); });
        }
        var lm = $('[data-load-more]');
        var newLm = doc.querySelector('[data-load-more]');
        if (lm) { if (newLm) lm.innerHTML = newLm.innerHTML; else lm.remove(); }
        window.history.replaceState({}, '', btn.getAttribute('href'));
      })
      .catch(function () { window.location.href = btn.getAttribute('href'); });
  });

  /* ---------------- Footer accordions (mobile) ---------------- */
  if (!isDesktop()) { $$('[data-footer-col]').forEach(function (d) { d.open = false; }); }

  /* ---------------- Newsletter popup ---------------- */
  var popup = $('[data-newsletter-popup]');
  function closePopup() {
    if (!popup || popup.hidden) return;
    popup.hidden = true;
    try { localStorage.setItem('calyre_popup', String(Date.now())); } catch (e) {}
  }
  if (popup) {
    var seen = null;
    try { seen = localStorage.getItem('calyre_popup'); } catch (e) {}
    var thirtyDays = 30 * 24 * 3600 * 1000;
    var posted = /customer_posted=true/.test(location.search);
    if (!posted && (!seen || Date.now() - parseInt(seen, 10) > thirtyDays)) {
      setTimeout(function () {
        if (!openDrawerEl && !searchOpen) popup.hidden = false;
      }, (parseInt(popup.getAttribute('data-delay'), 10) || 15) * 1000);
    }
    popup.addEventListener('click', function (e) {
      if (e.target === popup || e.target.closest('[data-popup-close]')) closePopup();
    });
    var pform = $('form', popup);
    if (pform) pform.addEventListener('submit', function () { try { localStorage.setItem('calyre_popup', String(Date.now() + 3650 * 24 * 3600 * 1000)); } catch (e) {} });
  }

  /* Keep theme editor happy */
  document.addEventListener('shopify:section:load', function (e) { initSliders(e.target); setHeaderHeight(); });
})();
